export default __webpack_public_path__ + "static/media/normal-candleChart-icon.153d79d2.svg";